import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'

import { itinerariesSchema } from '../ItinerariesCard/schema'
import { vehiclesSchema } from '../VehiclesCard/schema'
import { IServicesForm } from './types'
import { isEmpty } from 'lodash'
import { client } from 'gql/client'
import { GET_ROUTE_SERVICES_AUTOCOMPLETE } from 'features/Services/queries-legacy'
import { GTRouteServiceSuggestionsResponse } from 'gql/types.generated'
import { normalizeServiceCode } from 'features/Services/utils'

const messages = defineMessages({
  requiredCode: {
    id: 'service.form.code.required',
    defaultMessage: 'The code is required'
  },
  maxCode: {
    id: 'service.form.code.max',
    defaultMessage: 'The code can be up to 10 characters'
  },
  repeatedCode: {
    id: 'service.form.code.repeated',
    defaultMessage: 'Service code already exists'
  }
})

export const servicesFormSchema = (
  intl: IntlShape,
  {
    skipCodeVerification,
    isEndDateOptional
  }: {
    skipCodeVerification: boolean
    isEndDateOptional: boolean
  }
): yup.SchemaOf<IServicesForm> => {
  return yup.object().shape({
    reason: yup.string() as yup.SchemaOf<IServicesForm['reason']>,
    services: yup.array().of(
      yup
        .object()
        .shape({
          code: yup
            .string()
            .max(10, intl.formatMessage(messages.maxCode))
            .test('is-existing-code', intl.formatMessage(messages.repeatedCode), async (code) => {
              const newCode = normalizeServiceCode(code)
              if (skipCodeVerification || isEmpty(newCode)) return true

              const { data } = await client.query<{
                routeServiceSuggestions: GTRouteServiceSuggestionsResponse
              }>({
                query: GET_ROUTE_SERVICES_AUTOCOMPLETE,
                variables: { input: { normalizedCode: newCode } }
              })

              const suggestions = data?.routeServiceSuggestions.items ?? []
              return !suggestions.some((suggestion) => {
                return normalizeServiceCode(suggestion?.code) === newCode
              })
            })
            .required(intl.formatMessage(messages.requiredCode)),
          ...itinerariesSchema(intl, { isEndDateOptional }).fields,
          ...vehiclesSchema(intl).fields
        })
        .required()
    )
  })
}
